/* The theme's additions to the Risify app blocks, loaded by the Risify
   blocks section (sections/risify-blocks.liquid) so they work on any
   template, with or without the collection intro: product counts on the
   Similar chips, the Similar arrows, and a subtitle under the related
   searches title. Every Risify blocks section on the page loads this file;
   it runs once. */
if (!window.risifyBlocks) {
  window.risifyBlocks = true;

  /* The Similar block renders each chip as an image and a title; the count
     is fetched from the theme's own one-line section
     (sections/risify-collection-count.liquid), one small request per chip. */
  const countChips = () => {
    const apply = () => {
      document.querySelectorAll('.risify-collection-menu .risify-menu-item').forEach((item) => {
        if (item.dataset.countRequested) return;
        const title = item.querySelector('.risify-menu-item-title');
        const match = (item.getAttribute('href') || '').match(/^\/collections\/[^/?#]+/);
        if (!title || !match) return;
        item.dataset.countRequested = 'true';
        fetch(`${match[0]}?section_id=risify-collection-count`, { credentials: 'same-origin' })
          .then((res) => (res.ok ? res.text() : ''))
          .then((text) => {
            /* the count arrives inside Shopify's section wrapper div */
            const count = parseInt(text.replace(/<[^>]*>/g, '').trim(), 10);
            if (!isFinite(count)) return;
            const span = document.createElement('span');
            span.className = 'risify-menu-item-count';
            span.textContent = count;
            title.insertAdjacentElement('afterend', span);
          })
          .catch(() => {});
      });
    };
    apply();
    /* the app block may render, or render again, after this runs */
    const menu = document.querySelector('.risify-collection-menu');
    if (menu && 'MutationObserver' in window) {
      new MutationObserver(apply).observe(menu, { childList: true, subtree: true });
    }
  };

  /* The block's own arrows page by the average chip width, so with
     content-sized chips they can stop with the last chip cut off, or
     leave the row blank at the end. Once every script has run, the theme
     takes the arrows over (fresh buttons, so the block's handlers are
     gone) and pages by the chips' real edges, stopping exactly where the
     last chip meets the row's right edge. The block resets the row
     whenever the row's width changes (its own ResizeObserver since
     Risify's September 2026 update); so does this, so the arrows never
     disagree with the row. The same update appends the block id to the
     element ids (risify-prev-btn-<id>), so they are found by prefix. */
  const menuPaging = () => {
    const start = () => {
      const menu = document.querySelector('.risify-collection-menu');
      if (!menu) return;
      const track = menu.querySelector('.risify-menu-items');
      const oldPrev = menu.querySelector('[id^="risify-prev-btn"]');
      const oldNext = menu.querySelector('[id^="risify-next-btn"]');
      if (!track || !oldPrev || !oldNext) return;
      const prev = oldPrev.cloneNode(true);
      const next = oldNext.cloneNode(true);
      oldPrev.replaceWith(prev);
      oldNext.replaceWith(next);
      let shift = 0;
      const maxShift = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const edges = () => {
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        let x = 0;
        return Array.from(track.querySelectorAll('.risify-menu-item'), (item) => {
          const edge = x;
          x += item.offsetWidth + gap;
          return edge;
        });
      };
      /* The block shows or hides the arrows from its own measure, which it
         takes before the counts below widen the chips; with text-only chips
         the row can fit then and overflow afterwards, leaving no arrows.
         The row's real overflow decides here instead. */
      const controls = menu.querySelectorAll('.risify-pagination-controls');
      const apply = () => {
        const overflow = maxShift();
        track.style.transform = `translateX(-${shift}px)`;
        prev.disabled = shift <= 0;
        next.disabled = shift >= overflow - 1;
        controls.forEach((control) => {
          control.style.display = overflow > 0 ? 'flex' : 'none';
        });
      };
      next.addEventListener('click', (event) => {
        event.preventDefault();
        const edge = edges().find((x) => x > shift + 1);
        shift = Math.min(edge === undefined ? maxShift() : edge, maxShift());
        apply();
      });
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        const before = edges().filter((x) => x < shift - 1);
        shift = before.length ? before[before.length - 1] : 0;
        apply();
      });
      const reset = () => {
        shift = 0;
        apply();
      };
      if ('ResizeObserver' in window) new ResizeObserver(reset).observe(track);
      else window.addEventListener('resize', reset);
      /* chip widths change after the counts land and once the web font
         is in; the arrow states follow */
      if ('MutationObserver' in window) {
        new MutationObserver(apply).observe(track, { childList: true, subtree: true, characterData: true });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
      apply();
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  };

  /* The Risify related-searches block has a title setting but no subtitle;
     the design wants one, so the theme places the text set on the Risify
     blocks section that holds the block under its title. */
  const relatedSubtitle = () => {
    if (!document.querySelector('[data-related-searches-subtitle]')) return;
    const apply = () => {
      const block = document.querySelector('.risify-related-searches');
      if (!block || block.querySelector('.risify-related-searches-description')) return;
      const holder = block.closest('[data-related-searches-subtitle]');
      const title = block.querySelector('.risify-related-searches-title');
      if (!holder || !title) return;
      const p = document.createElement('p');
      p.className = 'risify-related-searches-description';
      p.textContent = holder.dataset.relatedSearchesSubtitle;
      title.insertAdjacentElement('afterend', p);
    };
    apply();
    if ('MutationObserver' in window) {
      new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
    }
  };

  countChips();
  menuPaging();
  relatedSubtitle();
}
